<template>
  <div>
    <v-container fluid>

      <v-snackbar v-model="alert" centered color="success" timeout="800" top>
        <v-icon dark left>mdi-check-circle</v-icon>
        Copié dans le presse-papier.
      </v-snackbar>

      <div class="main">
        <v-row>
          <v-col cols="12">
            <div class="d-flex justify-space-between mb-3">
              <v-spacer/>

              <v-btn class="rounded-lg"
                     color="gifty"
                     @click="openDialog"
                     dark
                     depressed
              >
                <v-icon left>mdi-import</v-icon>
                Importer
              </v-btn>
            </div>

            <v-card class="rounded-lg shadow">
              <v-overlay :value="overlay" absolute color="white" opacity="0.5">
                <v-progress-circular
                    color="primary"
                    indeterminate
                    size="50"
                ></v-progress-circular>
              </v-overlay>

              <v-card-title>
                <div>
                  <v-text-field
                      v-model="keyword"
                      append-icon="mdi-magnify"
                      clearable
                      dense
                      filled
                      hide-details
                      placeholder="Rechercher..."
                      rounded
                      single-line

                  />
                </div>
                <v-spacer/>
                <v-btn color="grey"
                       text
                       @click="getData">
                  <v-icon left>mdi-refresh</v-icon>
                  Mettre à jour
                </v-btn>
              </v-card-title>

              <v-divider/>

              <v-card-text v-if="isLoading">
                <v-skeleton-loader type="table"/>
              </v-card-text>

              <div v-else>
                <v-card-text>
                  <v-simple-table class="table-border rounded-lg" v-if="references.length">
                    <template v-slot:default>
                      <thead>
                      <tr>
                        <th>Référence</th>
                        <th>Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item ,index) in references" :key="index">

                        <td>
                          <div class="grey lighten-4 px-5 pa-1 my-2 rounded text-no-wrap" v-if="item.reference">
                            {{ item.reference }}
                            <v-btn color="gifty" icon @click="copy(item.reference)">
                              <v-icon small>mdi-content-copy</v-icon>
                            </v-btn>
                          </div>
                        </td>

                        <td>
                          <v-btn icon @click="remove(item.id)">
                            <v-icon>mdi-delete-outline</v-icon>
                          </v-btn>
                        </td>

                      </tr>
                      </tbody>
                    </template>
                  </v-simple-table>

                  <div v-else>
                    <NoResults @reload="getData"/>
                  </div>

                </v-card-text>
                <v-divider/>

                <v-card-actions>

                  <div :style="{width: '120px'}">
                    <v-select v-model="perPage"
                              :items="[10,20,30,50,100]"
                              dense
                              hide-details
                              label="Ligne par page"
                              outlined></v-select>
                  </div>

                  <v-spacer/>


                  <span class="text--darken-2 grey--text">
                      {{ pageStart }}-{{ pageEnd }} de {{ total }}
                  </span>
                  <v-pagination v-model="pagination.current"
                                :length="pagination.total"
                                circle
                                total-visible="8"
                                @input="getData"></v-pagination>

                </v-card-actions>

              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <v-dialog v-model="dialog" width="600" persistent>
        <v-card :loading="btnLoading" :disabled="btnLoading">
          <v-card-title>
            Importer
            <v-spacer/>
            <v-icon @click="dialog = false">mdi-close</v-icon>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-8">
            <v-alert text type="info">
              Le premier colonne de votre fichier Excel doit être l'en-tête.
              Assurez-vous que le fichier est au format .xlsx ou .csv.
            </v-alert>
            <v-file-input outlined
                          dense
                          ref="file"
                          label="Fichier Excel *"
                          @change="excelFile($event)"
                          :error-messages="errors.file"
                          hide-details="auto"
                          accept=".xlsx, .csv"/>

            <v-checkbox hide-details
                        color="gifty"
                        v-model="deleteNotExist"
                        label="Supprimer les références non incluses dans le nouveau fichier"
            />

          </v-card-text>
          <v-divider/>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="gifty" dark depressed @click="upload" :loading="btnLoading">
              <v-icon left>mdi-import</v-icon>
              Importer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";

export default {
  components: {NoResults},
  data() {
    return {
      id: '',
      keyword: '',
      dialog: false,
      btnLoading: false,
      overlay: false,
      isLoading: false,
      alert: false,
      deleteNotExist: false,
      file: null,
      errors: {},
      references: [],
      total: 0,
      perPage: 10,
      pagination: {
        current: 1,
        total: 0
      },
    };
  },
  methods: {
    openDialog() {
      this.dialog = true
      this.$refs.file?.reset()
      this.errors = {}
      this.deleteNotExist = false
    },
    excelFile(file) {
      this.file = file
    },
    upload() {
      this.btnLoading = true
      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('delete_not_exist', this.deleteNotExist ? 1 : 0)

      HTTP.post('/v1/heetch-references/import', formData).then(() => {
        this.btnLoading = false
        this.$successMessage = "Fichier importé avec succès!";
        this.dialog = false;
        this.getData();
      }).catch(err => {
        this.btnLoading = false
        this.errors = err.response.data.errors
        console.log(err)
      })
    },
    async copy(text) {
      this.alert = false
      try {
        await navigator.clipboard.writeText(text);
        this.alert = true
      } catch ($e) {
        console.log($e)
      }
    },
    getData() {
      this.isLoading = true
      HTTP.get('/v1/heetch-references?page=' + this.pagination.current, {
        params: {
          perPage: this.perPage,
          keyword: this.keyword
        }
      }).then(res => {

        this.pagination.current = res.data.data.current_page;
        this.pagination.total = res.data.data.last_page;
        this.total = res.data.data.total;

        this.references = res.data.data.data

        this.isLoading = false
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    remove(id) {
      this.id = id;
      this.$confirm_dialog = true;
    },
    deleteItem() {
      this.overlay = true;
      HTTP.post("/v1/heetch-references/delete", {
        id: this.id,
      }).then(() => {
        this.overlay = false;
        let i = this.references.findIndex((el) => el.id === this.id);
        this.$delete(this.references, i);
        this.id = null;
        this.$successMessage = "Cet élément a été supprimé avec succès.";
      }).catch((err) => {
        this.overlay = false;
        console.log(err);
      });
    },
  },
  created() {
    this.getData();
  },
  computed: {
    pageStart() {
      if (this.total === 0) return 0
      return (this.pagination.current - 1) * this.perPage + 1
    },
    pageEnd() {
      let end = this.pagination.current * this.perPage
      return end > this.total ? this.total : end
    }
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem();
        this.$is_confirm = false;
      }
    },
    perPage() {
      this.pagination.current = 1
      this.getData();
    },
    keyword() {
      this.getData();
    },
  }
};
</script>

<style scoped></style>
